import * as React from "react";

export interface NavGroup {
  label: string;
  items: { id: string; label: string }[];
}

export const NAV: NavGroup[] = [
  {
    label: "Branding",
    items: [
      { id: "colors", label: "Colors" },
      { id: "typography", label: "Typography" },
    ],
  },
  {
    label: "Structure",
    items: [
      { id: "shells", label: "Shells" },
      { id: "main-navigation", label: "Main navigation" },
      { id: "sub-navigation", label: "Sub navigation" },
      { id: "page-headers", label: "Page headers" },
      { id: "body-content", label: "Body content" },
      { id: "footers", label: "Footers" },
    ],
  },
  {
    label: "Elements",
    items: [
      { id: "iconography", label: "Iconography" },
      { id: "buttons", label: "Buttons" },
      { id: "forms", label: "Forms" },
      { id: "badges", label: "Badges" },
      { id: "toggle-buttons", label: "Toggle buttons" },
      { id: "listings", label: "Listings" },
      { id: "chart", label: "Chart" },
      { id: "modal", label: "Modal" },
      { id: "bottom-sheet", label: "Bottom sheet" },
      { id: "mobile-data-list", label: "Mobile data list" },
      { id: "dropdown-menu", label: "Dropdown menu" },
      { id: "callout", label: "Callout" },
      { id: "alert", label: "Alert" },
      { id: "chat", label: "Chat" },
    ],
  },
  {
    label: "Base styles",
    items: [
      { id: "heading-scale", label: "Heading scale" },
      { id: "h1", label: "H1" },
      { id: "h2", label: "H2" },
      { id: "h3", label: "H3" },
      { id: "h4", label: "H4" },
      { id: "h5", label: "H5" },
      { id: "h6", label: "H6" },
      { id: "anchor", label: "Anchor (a)" },
      { id: "paragraph", label: "Paragraph (p)" },
      { id: "strong", label: "Strong" },
      { id: "lists", label: "Lists (ul / ol)" },
      { id: "list-item", label: "List item (li)" },
      { id: "blockquote", label: "Blockquote" },
      { id: "label", label: "Label / legend" },
      { id: "hr", label: "Horizontal rule" },
    ],
  },
];

interface SidebarNavProps {
  activeSection: "branding" | "structure" | "elements" | "base-styles";
  activeId: string;
  onNavigate?: () => void;
}

export const GROUP_MAP: Record<string, string> = {
  branding: "Branding",
  structure: "Structure",
  elements: "Elements",
  "base-styles": "Base styles",
};

export function SidebarNav({ activeSection, activeId, onNavigate }: SidebarNavProps) {
  const filteredNav = React.useMemo(() => {
    const targetLabel = GROUP_MAP[activeSection];
    return NAV.filter((group) => group.label === targetLabel);
  }, [activeSection]);

  return (
    <nav className="flex flex-col gap-6 text-sm">
      {filteredNav.map((group) => (
        <div key={group.label}>
          <div className="mb-2 px-2 text-xs font-semibold uppercase tracking-wider text-ink-muted">
            {group.label}
          </div>
          <ul className="flex flex-col gap-0.5">
            {group.items.map((item) => {
              const isActive = activeId === item.id;
              return (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={onNavigate}
                    className={[
                      "block rounded-md px-2 py-1.5 no-underline transition-colors",
                      isActive
                        ? "bg-accent-faded text-accent-display"
                        : "text-ink-body hover:bg-surface hover:text-ink-display",
                    ].join(" ")}
                  >
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
